export const BETFEED_REFRESH = 'BETFEED_REFRESH';
export const BETFEED_LOADING = 'BETFEED_LOADING';
export const BETFEED_LOADING_ERROR = 'BETFEED_LOADING_ERROR';
export const BETFEED_LOADING_SUCCESS = 'BETFEED_LOADING_SUCCESS';
export const BETFEED_START_LISTENING_FOR_WS_UPDATES = 'BETFEED_START_LISTENING_FOR_WS_UPDATES';
export const BETFEED_STOP_LISTENING_FOR_WS_UPDATES = 'BETFEED_STOP_LISTENING_FOR_WS_UPDATES';
export const BETFEED_UPDATE_CARDS_FROM_WS = 'BETFEED_UPDATE_FROM_WS';
export const BETFEED_NEW_BETS = 'BETFEED_NEW_BETS';
export const BETFEED_ACTIVE_FILTER = 'BETFEED_ACTIVE_FILTER';
export const BETFEED_SELECT_FILTER_OPTION = 'BETFEED_SELECT_FILTER_OPTION';
export const BETFEED_RESET_FILTERS = 'BETFEED_RESET_FILTERS';
export const BETFEED_START_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES = 'BETFEED_START_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES';
export const BETFEED_STOP_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES = 'BETFEED_STOP_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES';
export const BETFEED_NUMBER_OF_PEOPLE_BET_UPDATE_FROM_WEBSOCKET_EVENTS = 'BETFEED_NUMBER_OF_PEOPLE_BET_UPDATE_FROM_WEBSOCKET_EVENTS';
export const BETFEED_SPORT_FILTERS = 'BETFEED_SPORT_FILTERS';
export const BETFEED_WIDGET_SPORT_CHANGE = 'BETFEED_WIDGET_SPORT_CHANGE';
